import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HomeService {

  isHomeSelected: boolean=false;
  constructor(private _http: HttpClient) {
  }

  setIsHomeSelected(value:boolean) {
    this.isHomeSelected = value;
  }

  getEngagementList(languageId:any): any {
    return this._http.get(environment.APIEndpoint+'api/Engagement/GetEngagementList?languageId=' + languageId)
      .map((res) => res)
      .catch(this._errorHandler);
  }
  _errorHandler(error: Response) {
    return Observable.throw(error || 'Server Error');
  }

  GetEngagementsForExternalUser(languageId): any {
    return this._http.get(environment.APIEndpoint+'api/Engagement/GetEngagementsForExternalUser?languageId=' + languageId)
      .map((res) => res)
      .catch(this._errorHandler);
  }

  GetPastEngagementsForExternalUser(languageId): any {
    return this._http.get(environment.APIEndpoint+'api/Engagement/GetPastEngagementsForExternalUser?languageId=' + languageId)
      .map((res) => res)
      .catch(this._errorHandler);
  }

  getPastEngagementList(languageId:any): any {
    return this._http.get(environment.APIEndpoint+'api/Engagement/GetPastEngagementList?languageId=' + languageId)
      .map((res) => res)
      .catch(this._errorHandler);
  }

  getEngagementById(engagementid): any {
    return this._http.get(environment.APIEndpoint+'api/Engagement/DownloadExcel?engagementId=' + engagementid)
      .map((res) => res)
      .catch(this._errorHandler);
  }

  getEngagementZipFolder(folderPath:any): any {
    return this._http.get(environment.APIEndpoint+'api/Engagement/DownloadZipFiles?folderName=' + folderPath, { responseType: 'blob'})
      .map((res) => res)
      .catch(this._errorHandler);
  }
  getEngagementDocsById(engagementid):any{
    return this._http.get(environment.APIEndpoint+'api/Engagement/GetEngagmentDocsById?engagementId=' + engagementid)
    .map((res) => res)
    .catch(this._errorHandler);
  }
  getEngagementDetailsById(engagementid,downloadedDocIds): any {
    return this._http.get(environment.APIEndpoint+'api/Engagement/DownloadExcel?engagementId=' + engagementid+'&&'+ 'strDocIds='+downloadedDocIds)
      .map((res) => res)
      .catch(this._errorHandler);
  }
}
